import React, { useState } from 'react';
import { PictureOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { feedPostPhotoUrl } from '../../lib/feedPostApi';
import { playerName } from '../../shared/utils/league-feed';
import { PhotoBurst, useDoubleTap, usePhotoState } from './photoEffects';

type Props = {
  event: LeagueFeed.Event;
  // Çift dokunma = beğeni; tek dokunmanın eylemi yok (beğeni düğmesi erişilebilir yol olarak kalır).
  onDoubleTap?: () => void;
  burst?: number;
};

/** Gönderi fotoğrafı: kart genişliğinde, 4:3 alan ayrılır (yüklenirken kayma olmaz). */
export default function FeedPostPhoto({ event, onDoubleTap, burst }: Props) {
  const { t } = useTranslation('leagues');
  const [failed, setFailed] = useState(false);
  // Dik fotoğrafta kare alan + üstten kırpma (geniş ekranda kafalar kesilmesin).
  const photo = usePhotoState(event.veri.foto_oran);
  const tap = useDoubleTap(undefined, onDoubleTap);
  return (
    <div
      className={`feed-post__photo${photo.portrait ? ' is-portrait' : ''}${
        photo.loading ? ' is-loading' : ''
      }`}
      onPointerUp={click => click.isPrimary && click.button === 0 && tap()}
    >
      {failed ? (
        <span className="feed-post__photo-error" role="img" aria-label={t('detail.posts.photoLoadError')}>
          <PictureOutlined aria-hidden="true" />
        </span>
      ) : (
        <img
          src={feedPostPhotoUrl(event.id)}
          alt={t('detail.posts.photoAlt', { name: playerName(event.veri.oyuncu) })}
          width={1200}
          height={900}
          loading="lazy"
          decoding="async"
          ref={photo.imageRef}
          className={photo.loading ? 'is-loading' : undefined}
          onLoad={photo.onLoad}
          onError={() => setFailed(true)}
        />
      )}
      <PhotoBurst burst={burst} />
    </div>
  );
}

FeedPostPhoto.defaultProps = { onDoubleTap: undefined, burst: undefined };
